import { backendApi } from "@/services/api";
import { ApiKey } from "@/services/backend/api-key/api-key";
import { Filter } from "@/shared/lib/filter/filter";

const apiKeyApi = backendApi.injectEndpoints({
  endpoints: (build) => ({
    createApiKey: build.mutation<PutResponse, PutRequest>({
      query: (request) => ({
        url: `/auth/api-keys`,
        method: "PUT",
        body: request,
      }),
      invalidatesTags: ["ApiKey"],
    }),
    deleteApiKey: build.mutation<DeleteResponse, DeleteRequest>({
      query: (request) => ({
        url: `/auth/api-keys`,
        method: "DELETE",
        body: request,
      }),
      invalidatesTags: ["ApiKey"],
    }),
    listApiKeys: build.query<List, ListRequest>({
      query: (request) => ({
        url: `/auth/api-keys`,
        method: "GET",
        params: {
          request: btoa(JSON.stringify(request)),
        },
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.items.map(({ id }) => ({
                type: "ApiKey" as const,
                id,
              })),
              { type: "ApiKey", id: "LIST" },
            ]
          : [{ type: "ApiKey", id: "LIST" }],
    }),
  }),
});

export const {
  useCreateApiKeyMutation,
  useListApiKeysQuery,
  useDeleteApiKeyMutation,
} = apiKeyApi;

interface PutRequest {
  id: string;
  customerId: string;
  exp: number;
  active: boolean;
}

interface PutResponse {
  result: string;
}

interface DeleteRequest {
  id: string;
}

interface DeleteResponse {}

interface ListRequest {
  customerId?: Filter<string>;
}

interface List {
  count: number;
  items: ApiKey[];
}
